import { Page } from "components";

export const Dashboard = () => {
  return <Page>Dashboard</Page>;
};
